import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Observable, throwError, from } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  map,
  shareReplay,
  switchMap,
} from 'rxjs/operators';
import { AppConfiguration } from 'src/app/app.configuration';
import { ConfigurationService } from 'src/app/core';
import { environment } from 'src/environments/pedrera/environment.development-pedrera';
import { Entrada } from '../../venta/models/entrada.model';
import {
  EntradaRestauracion,
  KoreTarifasDisponiblesResponse,
  ListadoKoreTarifasDisponible,
  PayloadKoreTarifasDisponibles,
} from '../models/entrada.microservicio.model';
import { VentaService } from '../../venta';

@Injectable({
  providedIn: 'root',
})
export class RestauracionService {
  constructor(
    private http: HttpClient,
    private config: AppConfiguration,
    private configuration: ConfigurationService,
    private ventaService: VentaService
  ) {}

  getCategorias(name: string[] = [], value: string[] = []): Observable<any[]> {
    var config = this.configuration.appConfig.getValue();

    var conexionId = JSON.parse(localStorage.getItem('conexionId') || 'null');
    var tpvId =
      this.configuration && this.configuration.datosTPVPathValue
        ? this.configuration.datosTPVPathValue.pkId
        : null;

    var filtrarPorCliente = 0;
    if (
      config &&
      config.DatosResult &&
      config.DatosResult.AppConfigJsonConfig &&
      config.DatosResult.AppConfigJsonConfig.ClienteFiltrarProductosPorCliente
    ) {
      filtrarPorCliente =
        config.DatosResult.AppConfigJsonConfig
          .ClienteFiltrarProductosPorCliente;
    }

    var codigoCliente = this.ventaService.clienteSeleccionadoValue;
    if (
      this.configuration &&
      this.configuration.internetConfig &&
      this.configuration.internetConfig.DatosResult &&
      this.configuration.internetConfig.DatosResult.ClienteId ===
        (codigoCliente && codigoCliente.Codigo)
    ) {
      codigoCliente = '0';
    } else {
      codigoCliente =
        codigoCliente && codigoCliente.Codigo ? codigoCliente.Codigo : '0';
    }

    if (!conexionId || !tpvId) {
      console.error('conexionId o tpvId no están definidos o son inválidos');
      return throwError(function () {
        return new Error('Error: conexiónId o tpvId inválido.');
      });
    }

    const filtrosName = name.concat([
      'tpvId',
      'codigoCliente',
      'filtrarPorCliente',
    ]);
    const filtrosValue = value.concat([
      tpvId.toString(),
      codigoCliente,
      filtrarPorCliente.toString(),
    ]);

    const baseUrl =
      this.config.getConfig('API_URL_MS') +
      '/api/Tienda/categoriasjerarquicasarbol';

    // Construcción con múltiples filtersnames y filtersvalues
    const queryParams = filtrosName
      .map(
        (filtro, i) =>
          `name=${encodeURIComponent(
            filtro
          )}&value=${encodeURIComponent(filtrosValue[i])}`
      )
      .join('&');

    const url = `${baseUrl}?conexionId=${conexionId}&${queryParams}`;

    return this.http.get(url, { responseType: 'json' }).pipe(
      distinctUntilChanged(),
      shareReplay(1),
      map(function (res: any) {
        return res && res.datosResult && res.datosResult.listado
          ? res.datosResult.listado
          : [];
      })
    );
  }

  getEntradasMicroservicesV2(
    categoriaId: number,
    cliente?,
    tipoElemento = '3',
    texto?
  ): Observable<Entrada[]> {
    const config = this.configuration.appConfig.getValue();

    let payload: PayloadKoreTarifasDisponibles = {
      Filtro: texto || '',
      Texto: '',
      TipoElemento: tipoElemento,
      CodigoCliente: cliente ? cliente.Codigo : '0',
      FiltrarPorCliente:
        config.DatosResult.AppConfigJsonConfig
          .ClienteFiltrarProductosPorCliente || 0,
      CategoriaId: categoriaId.toString(),
      TPVId: this.configuration.datosTPVPathValue.pkId || null,
    };

    if (texto) {
      delete payload.CategoriaId;
    }

    const URL = `${this.config.getConfig(
      'API_URL_MS'
    )}/api/Tienda/KoreTarifasDisponibles`;

    let params = new HttpParams();

    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        params = params.set(key, payload[key]);
      }
    }

    return this.http
      .get<KoreTarifasDisponiblesResponse>(URL, {
        params,
      })
      .pipe(distinctUntilChanged())
      .pipe(shareReplay(1))
      .pipe(
        map((res: KoreTarifasDisponiblesResponse) => {
          if (res === null || res.datosResult === null) {
            return [];
          }
          return res.datosResult.listadoKoreTarifasDisponibles.map(
            (tarifa: any) => this.transformarATipoEntrada(tarifa)
          );
        })
      );
  }


  getEntradasMicroservicesByFiltersV2(
    categoriaId: number,
    tipoElemento: number = 3,
    codigoCliente: string,
    tpvId?: number,
    texto?: string
  ): Observable<Entrada[]> {
    const config = this.configuration.appConfig.getValue();

    let payload: PayloadKoreTarifasDisponibles = {
      Filtro: texto || '',
      Texto: '',
      TipoElemento: tipoElemento.toString(),
      CodigoCliente: codigoCliente || '0',
      FiltrarPorCliente: config.DatosResult.AppConfigJsonConfig.ClienteFiltrarProductosPorCliente || 0,
      CategoriaId: categoriaId.toString(),
      TPVId: tpvId || this.configuration.datosTPVPathValue.pkId || null,
    }

    if (texto) {
      delete payload.CategoriaId;
    }

    const URL = `${this.config.getConfig('API_URL_MS')}/api/Tienda/KoreTarifasDisponibles`;

    let params = new HttpParams();

    for (const key in payload) {
      if (payload.hasOwnProperty(key)) {
        params = params.set(key, payload[key]);
      }
    }

    return this.http
      .get<KoreTarifasDisponiblesResponse>(
        URL,
        {
          params
        }
      )
      .pipe(distinctUntilChanged())
      .pipe(
        map((res: KoreTarifasDisponiblesResponse) => {
          if (res === null || res.datosResult === null) {
            return [];
          }
          return res.datosResult.listadoKoreTarifasDisponibles.map(
            (tarifa: any) => this.transformarATipoEntrada(tarifa)
          );
        })
      );
  }

  createToken() {
    const headers = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': 'true',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
    };
    const bodyToken = {
      usuario: environment.API_TOKEN_USER,
      contrasena: environment.API_TOKEN_PASSWORD,
    };
    return this.http
      .post(`${this.config.getConfig('API_URL_TAQUILLA')}/Token`, bodyToken, {
        headers: headers,
      })
      .pipe(
        map(async (res: any) => {
          return res.token;
        })
      );
  }

  private transformarATipoEntrada(tarifa: any): Entrada {
    return {
      FechaHoraEntrada: null, // Define el valor según tus reglas
      NombreTipo: tarifa.nombreTipo || '',
      Fecha: tarifa.fecha || '',
      id: tarifa.id || null,
      idTarifa: tarifa.idTarifa || '',
      GrupoTarifa: tarifa.grupoTarifa || '',
      noEditable: false, // Ajusta según necesidad
      ItemId: tarifa.itemId || '',
      CategoriaId: Number(tarifa.categoriaId) || 0,
      TipoEntradaId: tarifa.tipoEntradaId || '',
      TipoPromocionId: tarifa.tipoPromocionId || '',
      TipoAbonadoId: tarifa.tipoAbonadoId || '',
      GrupoId: tarifa.grupoId || '',
      GrupoMotivoId: tarifa.grupoMotivoId || '',
      NombrePantalla: tarifa.nombrePantalla || '',
      NombreImpresion: tarifa.nombreImpresion || '',
      NombreDisplay: tarifa.nombreDispay || '',
      Minimo: tarifa.minimo || '0',
      Maximo: tarifa.maximo || '0',
      Orden: tarifa.orden || '0',
      PrecioEnDivisaReferencia: tarifa.precioEnDivisaReferencia || '0',
      PrecioBase: tarifa.precioBase || '0',
      IVA: tarifa.iva || '0',
      Comision: tarifa.comision || '0',
      IvaComision: tarifa.ivaComision || '0',
      ComisionBase: tarifa.comisionBase || '0',
      DesglosarComision: tarifa.desglosarComision || '0',
      recintos: tarifa.recintos || [],
      motivos: [], // Llena según tus necesidades
      extraData: tarifa.argumentosCaracteristica
        ? JSON.parse(tarifa.argumentosCaracteristica)
        : null,
      auditorio:
        Array.isArray(tarifa.recintos) &&
        tarifa.recintos.some((r: any) => r.EsActividad === '1'),
      fechaAuditorio: '',
      horaAuditorio: '',
      idRecintoButaca: '',
      PromocionEntradas: tarifa.promocionEntradas || [],
      TipoProducto: tarifa.tipoProducto || '',
      BarCode: tarifa.barCodeStock || '',
      CaracteristicasEntrada: Object.entries(tarifa.caracteristicas || {}).map(
        ([key, value]) => ({
          clave: key,
          valor: value,
        })
      ),
      Cantidad: tarifa.cantidadCompra || '0',
      PosicionesVenta: tarifa.posicionesVenta || [],
      CuentaVisitante: tarifa.cuentaVisitante || '0',
      FarId: [],
      ImprimirTicket: tarifa.imprimirTicket || '0',
      ListaButacas: [],
      Modificado: false,
      NumOrdenPromos: [],
      NumOrdenPromosConEntradas: [],
      cantidad: tarifa.cantidadCompra || '0',
      PrecioTotal: tarifa.precioBase || '0',
      ControlAforoExterno:
        Array.isArray(tarifa.recintos) && tarifa.recintos.length > 0
          ? tarifa.recintos[0].ControlAforoExterno || ''
          : '',
      FechaHoraAccesoLocalizadorButaca: null,
      DNIAbonadosExt: null,
      desdeAsociado: false,
      codigoAsociado: null,
      ImporteDto: tarifa.importeDto || '',
      PrecioBaseConDto: tarifa.precioBaseConDto || '',
    };
  }
}
